export const localStorageKey = {
  userSortDropdown: 'userSortDropdown',
  fileOrLinkDropdown: 'fileOrLinkDropdown',
  isPdfViewerFirstVisit: 'isPdfViewerFirstVisit',
  fileBulkDropdown: 'fileBulkDropdown',
  fileMainDropdown: 'fileMainDropdown',
  fileMainViewType: 'fileMainViewType',
  linkMainDropdown: 'linkMainDropdown',
} as const;
